var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg4VLeft = function Svg4VLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.105 3.5 40.525 24l-19.42 20.5h-3.573l-.08-.16-8.126-9.357-.26-.3L6.93 24l2.137-10.684.26-.3 8.125-9.357.08-.159zm-3.667 34.104 1.949 3.896h.428l10.682-11.278zm-5.586-22.92L9.989 24l1.863 9.315 1.657 1.91-2.512-10.888L10.92 24l.077-.337 2.512-10.889zm4.617 20.021L32.757 25.5H14.345zM14.345 22.5h18.412L16.47 13.294zm3.093-12.104 13.06 7.381L19.814 6.5h-.428z"
  })));
};
export default Svg4VLeft;